import { BoardColumns } from '@/pages/customer-care/components';
import { listStatusWithCustomer } from '@/services/api-v3/customerStatus';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<BoardColumns[]>([]);
  const [valueEnum, setValueEnum] = useState<Record<string, { text: string }> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);
  const fetch = async () => {
    const res = await listStatusWithCustomer({
      pageSize: -1,
      filter: JSON.stringify({ active: true }),
    });
    setData(res as unknown as BoardColumns[]);
    setValueEnum(
      (res as unknown as BoardColumns[]).reduce(
        (pre: Record<string, { text: string }>, curr: API.CustomerStatus) => ({
          ...pre,
          [curr.id]: {
            text: curr.name,
          },
        }),
        {},
      ),
    );
    setValueOptions(
      (res as unknown as BoardColumns[]).map((item: API.CustomerStatus) => ({
        value: item.id,
        label: item.name,
      })),
    );
  };
  const reset = () => {
    setData([]);
    setValueEnum(null);
    setValueOptions([]);
  };
  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
